// extracted by mini-css-extract-plugin
module.exports = {"item":"tenderBoardListItemSkeleton_item__3C0R3","info":"tenderBoardListItemSkeleton_info__2_5YO","type":"tenderBoardListItemSkeleton_type__1B7XS"};